/** Collection of util functions that acts on objects */

/** Shallowly creates a new object with a prefix added to all keys */
export const prefixKeys = <S extends string, O extends object>(
  prefix: S,
  obj: O
): PrefixKeys<S, O> => {
  const newObj = {} as PrefixKeys<S, O>;
  Object.entries(obj).forEach(([key, value]) => {
    newObj[`${prefix}${key}` as keyof PrefixKeys<S, O>] = value;
  });
  return newObj;
};

/** Shallowly removes a prefix all objects keys */

export const removePrefixKeys = <S extends string, O extends object>(
  prefix: S,
  obj: O
): RemovePrefix<S, O> => {
  const newObj = {} as RemovePrefix<S, O>;
  Object.entries(obj)
    .sort(([key]) => (key.startsWith(prefix) ? 1 : -1))
    .forEach(([key, value]) => {
      newObj[
        `${
          key.startsWith(prefix) ? key.replace(prefix, "") : key
        }` as keyof RemovePrefix<S, O>
      ] = value;
    });
  return newObj;
};

// Filter things from a object, kind of like Array.filter
export const filterObject = (
  obj: Record<string, unknown>,
  test: (key: string) => boolean
) => {
  const nobj: Record<string, unknown> = {};
  Object.keys(obj).filter((key: string) => {
    if (test(key)) {
      nobj[key] = obj[key];
    }
  });
  return nobj;
};

// Remove suffix from object keys
export const removeSuffix = <T extends Record<string, unknown>>(
  obj: T,
  suffix: string
): Record<string, unknown> => {
  return Object.entries(obj).reduce(
    (acc: Record<string, unknown>, [key, value]) => {
      const newKey = key.endsWith(suffix) ? key.slice(0, -suffix.length) : key;

      acc[newKey] = value;
      return acc;
    },
    {}
  );
};
